import { makeStyles } from '@mui/styles'
const useStyleDeleteExtensionModal = makeStyles(() => ({
  cancelTypographyButton: {
    fontWeight: 700,
    marginTop: '5%',
    fontFamily: 'Raleway',
    color: '#263057',
    textTransform: 'capitalize',
    fontSize: '16px',
    '&:hover': {
      color: '#1BF57F'
    },
    fontStyle: 'normal',
    lineHeight: '23px'
  },
  typography: {
    mt: 2,
    marginTop: '5%',
    fontFamily: 'Roboto',
    color: '#263057'
  },
  dialogTypography: {
    mt: 2,
    marginTop: '5%',
    fontFamily: 'Roboto',
    color: '#263057'
  },
  confirmButton: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#00A88F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttons: {
    position: 'absolute',
    bottom: 18,
    display: 'flex',
    marginLeft: '40%',
    flexDirection: 'row-reverse'
  },
  confirmButtonTypography: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontStyle: 'normal',
    letterSpacing: '0.05em',
    lineHeight: '21px'
  },
  closeButton: {
    width: 90,
    height: 35,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeButtonColor: {
    color: '#263057',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    },
    fontWeight: 700,
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    lineHeight: '23px'
  }
}))

export default useStyleDeleteExtensionModal
